var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { Indicator } from '../Indicator';
import { INDICATOR_COLOR, INDICATOR_SIZE } from '../Indicator.constants';
import { INDICATOR_BADGE_PLACEMENT } from './IndicatorBadge.constants';
import styles from './IndicatorBadge.module.css';
const PLACEMENT_CLASS_MAP = {
    'bottom-right': styles.BottomRight,
    'top-right': styles.TopRight,
};
const PLACEMENT_SIZE_CLASS_MAP = {
    'bottom-right': {
        large: undefined,
        small: styles.BottomRightSmall,
        tiny: styles.BottomRightTiny,
    },
    'top-right': {
        large: styles.TopRightLarge,
        small: undefined,
        tiny: undefined,
    },
};
export const IndicatorBadge = ({ children, content, 'data-testid': testId, label, placement = INDICATOR_BADGE_PLACEMENT.BOTTOM_RIGHT, show = false, size = INDICATOR_SIZE.SMALL, variant = INDICATOR_COLOR.HIGHLIGHT, }) => (_jsxs("div", { className: styles.Container, children: [children, show && (_jsx(Indicator, { className: C(PLACEMENT_CLASS_MAP[placement], PLACEMENT_SIZE_CLASS_MAP[placement][size]), ...(testId && {
                'data-testid': testId,
            }), content: content, label: label, size: size, variant: variant }))] }));
_react_refresh_temp_1 = IndicatorBadge;
$RefreshReg$(_react_refresh_temp_1, "IndicatorBadge");
